import { SENTRY_DOMAIN } from 'shared/config'

export const getSentryReplaysLinkByOrganizationId = (id: number | string) => {
  if (!SENTRY_DOMAIN) return ''
  return `${SENTRY_DOMAIN}/organizations/sentry/replays/?query=organization.id%3A${id}&statsPeriod=24h`
}
